// extracted by mini-css-extract-plugin
export default {"listWrap":"categorylist_listWrap__VAeS8"};